module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS4.95a3dd9e.jpg";